videojs.addLanguage('ar', {
  "Play": "تشغيل",
  "Pause": "إيقاف",
  "Current Time": "الوقت الحالي",
  "Duration": "مدة",
  "Remaining Time": "الوقت المتبقي",
  "Stream Type": "نوع التيار",
  "LIVE": "مباشر",
  "Loaded": "تم التحميل",
  "Progress": "التقدم",
  "Fullscreen": "ملء الشاشة",
  "Non-Fullscreen": "تعطيل ملء الشاشة",
  "Mute": "صامت",
  "Unmute": "غير الصامت",
  "Playback Rate": "معدل التشغيل",
  "Subtitles": "الترجمة",
  "subtitles off": "إيقاف الترجمة",
  "Captions": "التعليقات",
  "captions off": "إيقاف التعليقات",
  "Chapters": "فصول",
  "You aborted the media playback": "لقد ألغيت تشغيل الفيديو",
  "A network error caused the media download to fail part-way.": "تسبب خطأ في الشبكة بفشل تحميل الفيديو بالكامل.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "لا يمكن تحميل الفيديو بسبب فشل في الخادوم أو الشبكة ، أو فشل بسبب عدم إمكانية قراءة تنسيق الفيديو.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "تم إيقاف تشغيل الفيديو بسبب مشكلة فساد أو لأن الفيديو المستخدم يستخدم ميزات غير مدعومة من متصفحك.",
  "No compatible source was found for this media.": "فشل العثور على أي مصدر متوافق مع هذا الفيديو.",
  "Play Video": "تشغيل الفيديو",
  "Close": "أغلق",
  "Modal Window": "نافذة مشروطة",
  "This is a modal window": "هذه نافذة مشروطة",
  "This modal can be closed by pressing the Escape key or activating the close button.": "يمكن غلق هذه النافذة المشروطة عن طريق الضغط على زر الخروج أو تفعيل زر الإغلاق",
  ", opens captions settings dialog": ", تفتح نافذة  خيارات التعليقات",
  ", opens subtitles settings dialog": ", تفتح نافذة  خيارات الترجمة",
  ", selected": ", مختار",
  "Audio Player": "مشغل الصوت",
  "Video Player": "مشغل الفيديو",
  "Replay": "إعادة التشغيل",
  "Seek to live, currently behind live": "ذهاب إلى نقطة البث المباشر، متأخر عن البث المباشر حاليًا",
  "Seek to live, currently playing live": "ذهاب إلى نقطة البث المباشر، البث المباشر قيد التشغيل حاليًا",
  "Progress Bar": "شريط التقدم",
  "Descriptions": "الأوصاف",
  "descriptions off": "إخفاء الأوصاف",
  "Audio Track": "المسار الصوتي",
  "Volume Level": "مستوى الصوت",
  "The media is encrypted and we do not have the keys to decrypt it.": "الوسائط مشفرة وليس لدينا الرموز اللازمة لفك شفرتها.",
  "Close Modal Dialog": "إغلاق مربع الحوار المشروط",
  ", opens descriptions settings dialog": "، يفتح مربع حوار إعدادات الأوصاف",
  "captions settings": "إعدادات التعليقات التوضيحية",
  "subtitles settings": "إعدادات الترجمات",
  "descriptions settings": "إعدادات الأوصاف",
  "Text": "النص",
  "White": "أبيض",
  "Black": "أسود",
  "Red": "أحمر",
  "Green": "أخضر",
  "Blue": "أزرق",
  "Yellow": "أصفر",
  "Magenta": "أرجواني",
  "Cyan": "أزرق سماوي",
  "Background": "الخلفية",
  "Window": "نافذة",
  "Transparent": "شفاف",
  "Semi-Transparent": "نصف شفاف",
  "Opaque": "معتم",
  "Font Size": "حجم الخط",
  "Text Edge Style": "نمط حواف النص",
  "None": "لا شيء",
  "Raised": "بارز",
  "Depressed": "منخفض",
  "Uniform": "منتظم",
  "Dropshadow": "ظل خلفي",
  "Font Family": "عائلة الخطوط",
  "Proportional Sans-Serif": "Proportional Sans-Serif",
  "Monospace Sans-Serif": "Monospace Sans-Serif",
  "Proportional Serif": "Proportional Serif",
  "Monospace Serif": "Monospace Serif",
  "Casual": "Casual",
  "Script": "Script",
  "Small Caps": "Small Caps",
  "Reset": "إعادة الضبط",
  "restore all settings to the default values": "استعادة كل الإعدادات إلى القيم الافتراضية",
  "Done": "تم",
  "Caption Settings Dialog": "مربع حوار إعدادات التعليقات التوضيحية",
  "Beginning of dialog window. Escape will cancel and close the window.": "بداية نافذة مربع حوار. الضغط على زر \"Escape\" سيؤدي إلى الإلغاء وإغلاق النافذة.",
  "End of dialog window.": "نهاية نافذة مربع حوار.",
  "{1} is loading.": "{1} قيد التحميل."
});